import styled from 'styled-components'

const Style = {
	Wrapper: styled.div`
		width: 800px;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 24px;

		& > h2 {
			${({theme}) => theme.font.large_bold};
		}
	`,
}
export default Style
